import { TabVm } from 'qp-ui-interface';

export const MENU_ITEM_IDS = {
  SUBSCRIBE: 'subscribe',
  LINK_TV: 'link-tv',
  MY_AHA: 'my-aha',
  SEARCH: 'search',
} as const;

export const MENU_ITEM_NAMES = {
  SUBSCRIBE: 'subscribe',
  LINK_TV: 'link_tv_header',
  MY_AHA: 'tabs.my_aha',
  SEARCH: 'tabs.search',
  HOME: 'tabs.home',
} as const;

export const MENU_ITEM_ICONS = {
  LINK: 'link',
  MY_AHA: 'my-aha',
  TELUGU: 'telugu',
  SEARCH: 'search',
  SHOWS: 'shows',
  HOME: 'home',
  MOVIES: 'movies',
  FREE: 'free',
} as const;

export const MENU_ITEMS: TabVm[] = [
  {
    name: MENU_ITEM_NAMES.SUBSCRIBE,
    id: MENU_ITEM_IDS.SUBSCRIBE,
  },
  {
    name: MENU_ITEM_NAMES.LINK_TV,
    icon: MENU_ITEM_ICONS.LINK,
    id: MENU_ITEM_IDS.LINK_TV,
  },
  {
    name: MENU_ITEM_NAMES.MY_AHA,
    icon: MENU_ITEM_ICONS.MY_AHA,
    id: MENU_ITEM_IDS.MY_AHA,
  },
  {
    name: MENU_ITEM_NAMES.SEARCH,
    icon: MENU_ITEM_ICONS.SEARCH,
    id: MENU_ITEM_IDS.SEARCH,
  },
];
